import { TUTORS, type Tutor } from './tutors';

/**
 * Картинки, которые уже пришли и раскодированы. `TutorAvatar` рисует такую
 * сразу, без шиммера и проявления: иначе даже картинка из кэша на каждом
 * заходе полсекунды «загружалась».
 */
const ready = new Set<string>();

export function isTutorImageReady(src: string): boolean {
  return ready.has(src);
}

export function markTutorImageReady(src: string): void {
  ready.add(src);
}

/**
 * Скачать и раскодировать картинки всех тьюторов, которых можно выбрать, —
 * заранее, в простое, вместе с чанком выбора собеседника (`PRELOAD_GROUPS`).
 * Без этого они начинали качаться только после тапа, и на телефоне карусель
 * стояла шиммером, пока не придут ~90 КБ.
 */
export function preloadTutorImages(kind: keyof NonNullable<Tutor['images']>): Promise<unknown> {
  const sources = TUTORS.flatMap((tutor: Tutor) =>
    tutor.images && !tutor.hidden ? [tutor.images[kind]] : [],
  );
  return Promise.allSettled(
    sources
      .filter((src) => !ready.has(src))
      .map((src) => {
        const image = new Image();
        image.src = src;
        return image.decode().then(() => ready.add(src));
      }),
  );
}
